module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTc3LjUgNDEuNWgtMjJ2LTM0bC0zMyA1MWgyMnYzNHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/car-features/ev.svg
// module id = 95UI
// module chunks = 1